import { useState } from "react";

import { CopyContentIcon, EditIcon } from "@dotnet/telematics-design-system";

import { useDialog } from "../../ActionBar/hooks";
import { DEVICE_MODEL_ACTIONS } from "../../types";
import { TITLES } from "../constants";

const useModelsInlineActions = () => {
    const { isOpenDialog, closeDialog, openDialog } = useDialog();

    const [rowData, setRowData] = useState(null);

    const openModelDialog = (
        dialogName:
            | DEVICE_MODEL_ACTIONS.CloneModel
            | DEVICE_MODEL_ACTIONS.EditModel,
        data: any
    ) => {
        setRowData(data);
        openDialog(dialogName);
    };

    const closeModelDialog = (
        dialogName:
            | DEVICE_MODEL_ACTIONS.CloneModel
            | DEVICE_MODEL_ACTIONS.EditModel
    ) => {
        setRowData(null);
        closeDialog(dialogName);
    };

    const inlineActions = [
        {
            title: TITLES.CloneModel,
            icon: CopyContentIcon,
            clickAction: (data: any) =>
                openModelDialog(DEVICE_MODEL_ACTIONS.CloneModel, data)
        },
        {
            title: TITLES.EditModel,
            icon: EditIcon,
            clickAction: (data: any) =>
                openModelDialog(DEVICE_MODEL_ACTIONS.EditModel, data)
        }
    ];

    return {
        modelInlineActions: inlineActions,
        modelRowData: rowData,
        isCloneModelOpen: isOpenDialog[DEVICE_MODEL_ACTIONS.CloneModel],
        isEditModelOpen: isOpenDialog[DEVICE_MODEL_ACTIONS.EditModel],
        closeModelDialog
    };
};

export { useModelsInlineActions };
